import { Checkbox } from 'antd';
import { RowCentered, Text } from '@ydistri/ds';
import React from 'react';
import AsoTooltip from '../AsoTooltip';

interface AsoSourceControlsProps {
  isDisabled: boolean;
  isForced: boolean;
  isForcedToZero: boolean;
  onForcedChange: (value: boolean) => void;
  onForcedToZeroChange: (value: boolean) => void;
  scopeId: number;
}

const AsoSourceControls: React.FC<AsoSourceControlsProps> = ({
  isDisabled,
  isForced,
  isForcedToZero,
  onForcedChange,
  onForcedToZeroChange,
  scopeId,
}) => (
  <RowCentered $gap="1rem">
    <RowCentered $gap="0.25rem">
      <Checkbox
        id={`aso-source-${scopeId}-forced`}
        checked={isForced}
        disabled={isDisabled}
        onChange={event => onForcedChange(event.target.checked)}
      />
      <Text as="label" htmlFor={`aso-source-${scopeId}-forced`} $pointer>
        Forced
      </Text>
      <AsoTooltip tooltipKey="forcedSource" />
    </RowCentered>
    <RowCentered $gap="0.25rem">
      <Checkbox
        id={`aso-source-${scopeId}-forcedToZero`}
        checked={isForcedToZero}
        disabled={isDisabled}
        onChange={event => onForcedToZeroChange(event.target.checked)}
      />
      <Text as="label" htmlFor={`aso-source-${scopeId}-forcedToZero`} $pointer>
        Forced to zero
      </Text>
      <AsoTooltip tooltipKey="forcedToZeroSource" />
    </RowCentered>
  </RowCentered>
);

export default AsoSourceControls;
